import React, { PureComponent } from 'react'
import cx from 'classnames'
import config from 'app-config'
import actions from 'redux/actions'
import { compose } from 'helpers'
import { connect } from 'redaction'
import ResizableModal from 'react-modal-resizable-draggable'

import toggleOpen from 'local_modules/toggleOpen'
import injectGlobals from 'local_modules/injectGlobals'

import Box from 'components/layout/Box/Box'
import Text from 'components/typography/Text/Text'
import Loader from 'components/ui/Loader/Loader'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'

import s from './ChatWidget.scss'


const icons = [
  'ic_bell.svg',
  'ic_bell_hover.svg',
]


class ChatWidget extends PureComponent {

  interval = null

  state = {
    isMouseDown: false,
    isDisabled: false,
  }

  componentDidMount() {
    const { interval } = this.props

    actions.ui.getChat()

    this.interval = setInterval(() => actions.ui.getChat(), interval)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  toggleChatWindow = () => {
    const { isToggleActive, toggleOpen, toggleClose } = this.props

    if (isToggleActive) {
      toggleClose()
    }
    else {
      toggleOpen()
    }
  }

  setMouseDown = () => {
    this.setState({
      ...this.state,
      isMouseDown: true,
    })
  }

  setMouseUp = () => {
    this.setState({
      ...this.state,
      isMouseDown: false,
    })
  }

  render() {
    const { isMouseDown, isDisabled } = this.state
    const { host, unread, isToggleActive, setRef } = this.props

    return (
      <span ref={setRef}>
        <Box
          className={s.icon}
          ml="24"
          pl="8"
          pr="8"
          onClick={this.toggleChatWindow}
        >
          <Box pr="8">
            {
              icons.map((icon, index) => (
                <img
                  key={index}
                  className={cx({
                    [s.hover]: /hover/.test(icon),
                    [s.default]: !/hover/.test(icon),
                  })}
                  src={`${host}/img/${icon}`}
                />
              ))
            }
            {
              Boolean(unread) && (
                <Box className={s.unread} pl="8" pr="8">
                  <Text
                    className={s.text}
                    message={unread}
                    size="12-14"
                    color="white"
                  />
                </Box>
              )
            }
          </Box>
        </Box>
        <ResizableModal
          isOpen={isToggleActive}
          className={s.chatWindow}
          initWidth={640}
          initHeight={474}
          top={100}
          left={window.innerWidth > 650 ? window.innerWidth - 650 : 100}
        >
          <div className={s.close}>
            <CloseIcon
              color="white"
              onClick={this.toggleChatWindow}
            />
          </div>
          <iframe
            className={s.iframe}
            src={`${host}/index_chat.php?noFio=true`}
            frameBorder="0"
          />
          <Loader
            className={s.loader}
            color="white"
          />
        </ResizableModal>
      </span>
    )
  }
}


export default compose(
  injectGlobals(({ globals }) => ({
    host: config.api === 'test' ? 'https://smartsarov.ru' : `https://${globals.host || 'smartsarov.ru'}`,
  })),
  connect({
    unread: 'ui.chat.unread',
  }),
  toggleOpen({ toggleOnWindowClick: false })
)(ChatWidget)
